import { useMediaQuery } from '@mui/material'

export const usePrefersReducedMotion = () => useMediaQuery('(prefers-reduced-motion: reduce)')
